<template>
  <div>
    <splash-screen v-if="currentScreen == SPLASH" @start="currentScreen = FORM"></splash-screen>

    <div id="activity" v-if="currentScreen == FORM ">
      <div class="bg-gray-800 pb-32">
        <navbar></navbar>
        <my-header
          v-show="!creatingScenario"
          @back="currentScreen = SPLASH"
          :new-project-name="newProjectName"
        ></my-header>
      </div>
      <main class="-mt-32">
        <div class="max-w-7xl mx-auto px-4 pb-12 sm:px-6 lg:px-8">
          <div class="bg-white shadow overflow-hidden rounded-md">
            <transition-animation>
              <project-info
                v-show="!creatingScenario"
                :cities="sortedCities"
                :states="states"
                :project-info="projectInfo"
                ref="projectInfoSection"
              ></project-info>
            </transition-animation>
            <transition-animation>
              <personal-info
                :personal-info="personalInfo"
                ref="personalInfoSection"
                v-show="!creatingScenario"
                class="md:border-t md:border-gray-200 md:pt-6"
                :cities="sortedCities"
                :states="states"
                :project-info="projectInfo"
              ></personal-info>
            </transition-animation>
            <transition-animation>
              <project-dimensions
                :project-dimensions="projectDimensions"
                ref="projectDimensionsSection"
                v-show="!creatingScenario"
                class="md:border-t md:border-gray-200 md:pt-6"
              ></project-dimensions>
            </transition-animation>

            <transition-animation>
              <scenarios
                @adding-scenario="creatingScenario = true"
                @scenario-removed="removeScenario"
                :scenarios="scenarios"
                ref="scenariosSection"
                :material="material"
                v-show="!creatingScenario"
              ></scenarios>
            </transition-animation>

            <transition-animation>
              <new-scenario
                :doors-options="doorsOptions"
                :material="material"
                :lastScenario="lastScenario"
                v-if="creatingScenario"
                @scenario-added="addScenario"
                @cancel-adding-scenario="creatingScenario = false"
              ></new-scenario>
            </transition-animation>

            <div class="justify-end flex mt-2 m-8" v-show="!creatingScenario">
              <button
                type="button"
                @click="submit"
                class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-suma hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-600 transition duration-150 ease-in-out"
                :disabled=isCalculating
                :class="isCalculating ? 'cursor-not-allowed' : 'hover:bg-indigo-500'"
              >
                <svg v-if="isCalculating" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                  </circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                  </path>
                </svg>
                <svg v-else
                  class="-ml-1 mr-2 h-5 w-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
                {{this.isCalculating ? "Calculando" : "Calcular"}}
              </button>
            </div>

            <action-modal
              ref="validationModal"
              type="danger"
              title="Campos faltantes"
              text="Algunos campos se encuentran vacios o incorrectos. Favor de revisarlos e intentar nuevamente."
              action-text="Revisar"
            ></action-modal>

            <action-modal
              ref="errorModal"
              type="danger"
              title="Ocurrio un error"
              text="Ocurrió un error inesperado. Por favor intenta más tarde."
              action-text="Aceptar"
            ></action-modal>

            <action-modal
              @accepted="currentScreen = SPLASH"
              ref="successFormModal"
              type="success"
              title="Información enviada correctamente"
              text="Hemos recibido su información correctamente. Te enviaremos un correo con los resultados."
              action-text="Aceptar"
            ></action-modal>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  computed: {
    states() {
      return [...new Set(this.cities.map((a) => a.state.trim()))].sort();
    },

    sortedCities() {
      let cities = this.cities;
      let sortedCities = cities.sort((a, b) => (a.city > b.city ? 1 : -1));

      return sortedCities;
    },
    newProjectName() {
      return this.projectInfo.name
        ? 'Proyecto ' + this.projectInfo.name
        : 'Nuevo Proyecto';
    },
    formatedScenarios() {
      let scenarios = [];
      let scenarioNumber = 1;
      this.scenarios.forEach((scenario) => {
        scenarios.push({
          scenario_id: scenarioNumber,
          scenario_name: 'Escenario ' + scenarioNumber,
          materials: {
            slab: {
              slab_id: scenario.slab_material,
              outer_material_id: scenario.slab_exterior_finishes,
              inner_material_id: scenario.slab_interior_finishes,
            },
            wall: {
              wall_id: scenario.wall_material,
              outer_material_id: scenario.wall_exterior_finishes,
              inner_material_id: scenario.wall_interior_finishes,
            },
            door_id: scenario.doors_material,
            is_glass_door: scenario.doors_are_made_of_glass,
            window_id: scenario.glass_material,
          },
        });
        scenarioNumber++;
      });

      return scenarios;
    },
    formData() {
      return {
        scenarios: this.formatedScenarios,
        dimensions: {
          facade_facing: this.projectDimensions.orientation_front,
          roof: {
            solid: Number(this.projectDimensions.roof_solid_m2),
            glass: this.projectDimensions.roof_has_glass
              ? Number(this.projectDimensions.roof_glass_m2)
              : 0,
          },
          north: {
            solid: Number(this.projectDimensions.north_wall_solid_m2),
            glass: this.projectDimensions.north_wall_has_glass
              ? Number(this.projectDimensions.north_wall_glass_m2)
              : 0,
            door: this.projectDimensions.north_wall_has_doors
              ? Number(this.projectDimensions.north_wall_doors_m2)
              : 0,
          },
          east: {
            solid: Number(this.projectDimensions.east_wall_solid_m2),
            glass: this.projectDimensions.east_wall_has_glass
              ? Number(this.projectDimensions.east_wall_glass_m2)
              : 0,
            door: this.projectDimensions.east_wall_has_doors
              ? Number(this.projectDimensions.east_wall_doors_m2)
              : 0,
          },
          south: {
            solid: Number(this.projectDimensions.south_wall_solid_m2),
            glass: this.projectDimensions.south_wall_has_glass
              ? Number(this.projectDimensions.south_wall_glass_m2)
              : 0,
            door: this.projectDimensions.south_wall_has_doors
              ? Number(this.projectDimensions.south_wall_doors_m2)
              : 0,
          },
          west: {
            solid: Number(this.projectDimensions.west_wall_solid_m2),
            glass: this.projectDimensions.west_wall_has_glass
              ? Number(this.projectDimensions.west_wall_glass_m2)
              : 0,
            door: this.projectDimensions.west_wall_has_doors
              ? Number(this.projectDimensions.west_wall_doors_m2)
              : 0,
          },
        },
        number_of_buildings: 1,
        rate: this.projectDimensions.project_type,
        client_information: {
          name: this.personalInfo.name,
          address: this.personalInfo.address,
          colonia: this.personalInfo.town,
          postal_code: this.personalInfo.postal_code,
          telephone: this.personalInfo.phone,
          state_id: this.personalInfo.state,
          city_id: this.personalInfo.city,
          email: this.personalInfo.email,
        },
        project_information: {
          name: this.projectInfo.name,
          address: this.projectInfo.address,
          colonia: this.projectInfo.town,
          postal_code: this.projectInfo.postal_code,
          state_id: this.projectInfo.state,
          city_id: this.projectInfo.city,
        },
      };
    },
  },
  data() {
    this.SPLASH = 'splash';
    this.FORM = 'form';
    this.LIBRARY = 'library';
    return {
      isCalculating: false,
      currentScreen: this.SPLASH,
      scenarios: [],
      lastScenario: null,
      creatingScenario: false,
      projectInfo: {
        name: '',
        state: '',
        city: '',
        address: '',
        town: '',
        postal_code: '',
      },
      personalInfo: {
        name: '',
        email: '',
        phone: '',
        state: '',
        city: '',
        address: '',
        town: '',
        postal_code: '',
      },
      projectDimensions: {
        project_type: '',
        orientation_front: '',
        roof_has_glass: true,
        roof_glass_m2: 0,
        roof_solid_m2: 0,
        north_wall_has_glass: true,
        north_wall_has_doors: true,
        north_wall_glass_m2: 0,
        north_wall_solid_m2: 0,
        north_wall_doors_m2: 0,
        south_wall_has_glass: true,
        south_wall_has_doors: true,
        south_wall_glass_m2: 0,
        south_wall_solid_m2: 0,
        south_wall_doors_m2: 0,
        east_wall_has_glass: true,
        east_wall_has_doors: true,
        east_wall_glass_m2: 0,
        east_wall_solid_m2: 0,
        east_wall_doors_m2: 0,
        west_wall_has_glass: true,
        west_wall_has_doors: true,
        west_wall_glass_m2: 0,
        west_wall_solid_m2: 0,
        west_wall_doors_m2: 0,
      },
      cities: constants.getCities(),
      doorsOptions: [
        { key: false, name: 'No son de vidrio' },
        { key: true, name: 'Son de vidrio' },
      ],
      material: {
        walls: constants.getWalls(),
        slabs: constants.getSlabs(),
        doors: constants.getDoors(),
        composite: constants.getComposites(),
        windows: constants.getWindows(),
      },
    };
  },
  methods: {
    addScenario(scenario) {
      let newScenario = {
        doors_are_made_of_glass: scenario.doors_are_made_of_glass,
        doors_material: scenario.doors_material,
        glass_material: scenario.glass_material,
        wall_material: scenario.wall_material,
        wall_interior_finishes: scenario.wall_interior_finishes,
        wall_exterior_finishes: scenario.wall_exterior_finishes,
        slab_material: scenario.slab_material,
        slab_interior_finishes: scenario.slab_interior_finishes,
        slab_exterior_finishes: scenario.slab_exterior_finishes,
      };
      this.scenarios.push(newScenario);
      this.lastScenario = newScenario;
      this.creatingScenario = false;
    },
    removeScenario(scenario) {
      this.scenarios.splice(scenario, 1);
    },
    submit() {
      this.$refs.projectInfoSection.$v.$touch();
      this.$refs.personalInfoSection.$v.$touch();
      this.$refs.projectDimensionsSection.$v.$touch();
      this.$refs.scenariosSection.$v.$touch();

      if (
        !this.$refs.projectInfoSection.$v.$invalid &&
        !this.$refs.personalInfoSection.$v.$invalid &&
        !this.$refs.projectDimensionsSection.$v.$invalid &&
        !this.$refs.scenariosSection.$v.$invalid
      ) {
        this.isCalculating = true;
        axios
          .post(
            '/PdfGen',
            { payload: this.formData },
            { responseType: 'arraybuffer' }
          )
          .then((response) => {
            let blob = new Blob([response.data], { type: 'application/pdf' });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'suma-verde.pdf';
            link.click();
            this.$refs.successFormModal.open();
            this.isCalculating = false;
          })
          .catch((response) => {
            this.$refs.errorModal.open();
            this.isCalculating = false;
          });
      } else {
        this.$refs.validationModal.open();
      }
    },
  },
};
</script>
